// Utils
import { enterprisePayeesPayrollConf } from "app/main/finance/enterprise-payroll/enterprisePayeesPayrollConf.js";

const enterprisePayrollList = enterprisePayeesPayrollConf;

export default enterprisePayrollList;
